import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

const HTTP_FORBIDDEN = 403;

export const useAuditLogs = (entityType, search) => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [forbidden, setForbidden] = useState(false);

  const load = useCallback((skip = 0) => {
    api.get("/audit-logs", { params: { entity_type: entityType, search, skip, limit: 50 } })
      .then((r) => {
        setTotal(r.data.total);
        setLogs((prev) => (skip === 0 ? r.data.logs : [...prev, ...r.data.logs]));
      })
      .catch((err) => { if (err.response?.status === HTTP_FORBIDDEN) setForbidden(true); });
  }, [entityType, search]);

  useEffect(() => {
    const t = setTimeout(() => load(0), search ? 300 : 0);
    return () => clearTimeout(t);
  }, [load, search]);

  return { logs, total, forbidden, loadMore: () => load(logs.length) };
};
